import React from "react";
import './AlertCard.sass';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import CloseIcon from '@mui/icons-material/Close';

interface AlertCardProps {
    title: string;
    message: React.ReactNode;    
    onContinue?: () => void;
    onReview?: () => void;
    continueText?: string;
    reviewText?: string;
    onClose?: () => void;
}

const AlertCard = ({
    title, 
    message,
    onContinue,
    onReview,
    onClose,
    continueText = 'Continuar',
    reviewText = 'Revisar',
}: AlertCardProps) => {
    const hasActions = onContinue || onReview;

    return (
    <div className="alert-overlay">
        <div className={`alert-card ${!hasActions ? 'compact' : ''}`}>
            {onClose && (
                <button className="alert-close" onClick={onClose} aria-label="Fechar">
                    <CloseIcon fontSize="small" />
                </button>
            )}
            <h2 className="alert-title">{title}</h2>
            <p className="alert-message">{message}</p>

            {hasActions && (
            <div className="alert-actions">
                {onContinue && (
                <button className="alert-continue" onClick={onContinue}>
                    {continueText}
                </button>
                )}
                {onReview && (
                <button className="alert-review" onClick={onReview}>
                    <ArrowBackIcon fontSize="medium" />
                    {reviewText}
                </button>
                )}
            </div>
            )}
        </div>
    </div>
  );
};

export default AlertCard;